// Dependencies
import LeoSelect from '../../../components/form/LeoReactSelect';

interface PricelevelProps {
	priceLevels: any[],
	selectedPriceLevelUUID?: any,
	onChange: any
}

const defaultProps = {
	priceLevels: [],
};
function Pricelevel(propsIn : PricelevelProps) {
	const props = {...defaultProps, ...propsIn};
	const selectedPriceLevelUUID = props.selectedPriceLevelUUID ||
		props.priceLevels[0].priceLevelUuid;
	const selectedPriceLevel = props.priceLevels.find(pl => pl.priceLevelUuid === selectedPriceLevelUUID);
	
	const selectOptions = [{value: 0, label: 'Preisstufe', isSelected: false, isDisabled: true}]
	props.priceLevels.map(priceLevel => {
			if(!priceLevel.hideOnline){
				selectOptions.push( {
					value: priceLevel.priceLevelUuid,
					label: `${priceLevel.name} (${parseFloat(priceLevel.price.value).toFixed(2)} €) ${priceLevel.forSponsors ? " ★" : ""}`,
					isSelected: priceLevel.priceLevelUuid === selectedPriceLevelUUID,
					isDisabled: false
				})
			}
	})
	
	return props.priceLevels.length > 0 ?
		(
			<div>
				<LeoSelect
					name="pricelevel"
					value={selectedPriceLevelUUID}
					id={'pl_' + selectedPriceLevelUUID}
					valueInput={`${selectedPriceLevel.name} (${parseFloat(selectedPriceLevel.price.value)
						.toFixed(2)}€) ${selectedPriceLevel.forSponsors ? " ★" : ""}`}
					labeledById={"pl_headline"}
					onChange={props.onChange}
					placeholder="Preisstufe"
					options={selectOptions}
				>
				</LeoSelect>

			</div>
		) : null;
}

export default Pricelevel;
